export const calculateInterventions = (order) => {
    if (order.issue) {
        return { issue: order.issue };
    }

    if (order.minutesOverdue > 0) {
        return { issue: "SLA_VIOLATION" };
    }

    return { issue: null };
};

export const getContactInfo = (order, issue) => {
    if (!order) return null;

    switch (issue) {
        case "NOT_ACCEPT":
        case "NOT_READY":
            return {
                name: order.restaurant?.businessInfo?.name || "Business",
                phone: order.restaurant?.businessInfo?.phoneNumber,
            };
        case "NOT_PICKED":
            if (order.deliveryType === "DELIVERY") {
                return {
                    name: "Delivery Person",
                    phone: order.biker?.user?.phoneNumber || order.contactPhone,
                };
            }
            return {
                name: `${order.user?.firstName || ""} ${order.user?.lastName || ""}`.trim() || "Customer",
                phone: order.user?.phoneNumber || order.contactPhone,
            };
        case "NOT_DELIVERED":
            return {
                name: "Delivery Person",
                phone: order.biker?.user?.phoneNumber || order.contactPhone,
            };
        default:
            return {
                name: order.user ? `${order.user.firstName || ""} ${order.user.lastName || ""}`.trim() || "Customer" : "Customer",
                phone: order.contactPhone || order.user?.phoneNumber,
            };
    }
};
